import { Box, Typography } from '@mui/material';
import { HAIRLINE } from '../colors';
import { CustomerPaymentTotals } from '../../../../types/customers';
import { formatDollarAmount } from '../../../../utils/global/helper';

interface Props {
  totals: CustomerPaymentTotals;
}

function StatBlock({ value, label }: { value: string; label: string }) {
  return (
    <Box>
      <Typography variant="h2" sx={{ color: 'text.primary' }}>
        {value}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: 'text.secondary', marginTop: '5px' }}>
        {label}
      </Typography>
    </Box>
  );
}

function PaymentsStatsRow({ totals }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: { xs: '24px', sm: '48px' },
        paddingBottom: '28px',
        borderBottom: `1px solid ${HAIRLINE}`,
      }}>
      <StatBlock
        value={formatDollarAmount(totals.totalPaid)}
        label="Total paid"
      />
      <StatBlock
        value={formatDollarAmount(totals.averageTransaction)}
        label="Average transaction"
      />
      <StatBlock
        value={formatDollarAmount(totals.outstandingBalance)}
        label="Outstanding balance"
      />
    </Box>
  );
}

export default PaymentsStatsRow;
